export default __webpack_public_path__ + "media/images/brands/demo/other/mission-3804cc289d7405989b3d2e5756bdbad7.jpg";